/**
 * Endpoints of all Public APIs (unprotected)
 * 
 */

export const Public_Login = "public/auth/login" 
export const Search_Properties = "public/listing/search/"
export const Verify_OTP = "public/auth/verify_account"